import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/core';

import theme from './theme';
import './index.scss';

import App from './App';
import ErrorBoundary from '@/ErrorBoundary';
import store from './store';
import * as serviceWorker from '#/serviceWorker';
import history from '#/history';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity
        }
    }
});

export const AppWrapper = (
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <ConnectedRouter basename='' history={history}>
                <ThemeProvider theme={theme}>
                    <ErrorBoundary>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <App />
                        </MuiPickersUtilsProvider>
                    </ErrorBoundary>
                </ThemeProvider>
            </ConnectedRouter>
        </Provider>
        {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
);

ReactDOM.render(AppWrapper, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
